<template>
  <div class="saleRate_add">
    <div class="saleRate_content">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-position="left"
      >
        <!-- 基本信息 -->
        <div class="saleRate_add_info">
          <div class="saleRate_add_title">基本信息</div>
          <div class="saleRate_add_content">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="费率名称" prop="ormtb608ca01">
                  <el-input
                    v-model="ruleForm.ormtb608ca01"
                    placeholder="请输入费率名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="下发时间" prop="ormtb608ca15">
                  <el-date-picker
                    v-model="ruleForm.ormtb608ca15"
                    type="datetime"
                    placeholder="请选择日期时间"
                    :picker-options="pickerOptions"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="下发范围" prop="ormtb601id">
                  <el-select
                    v-model="ruleForm.list"
                    multiple
                    style="width:100%;"
                    placeholder="请选择"
                    @change="getSelectData"
                  >
                    <el-option
                      v-for="item in stationList"
                      :key="item.ormtb601id"
                      :label="item.ormtb601ca00"
                      :value="item.ormtb601id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="计费说明" prop="ormtb608ca02">
                  <el-input
                    v-model="ruleForm.ormtb608ca02"
                    type="textarea"
                    maxlength="50"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <!-- 设置电费/服务费 -->
        <div class="saleRate_setup">
          <div class="saleRate_add_title">设置电费/服务费</div>
          <div class="saleRate_add_content">
            <div class="saleRate_add_content_title">计费模式</div>
          </div>
          <div class="saleRate_setup_radio">
            <el-radio-group v-model="ruleForm.ormtb608ca04">
              <el-radio :label="0">标准计费（00:00 - 24:00）</el-radio>
              <el-radio :label="1">分时计费（尖峰平谷）</el-radio>
            </el-radio-group>
          </div>
        </div>
        <!-- 标准计费 -->
        <div class="standard_electricity_fee" v-if="ruleForm.ormtb608ca04 == 0">
          <div class="saleRate_add_title">标准电费</div>
          <div class="standard_electricity_fee_content">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="标准电费" prop="ormtb608ca05">
                  <el-input-number
                    v-model="ruleForm.ormtb608ca05"
                    :precision="2"
                    :step="0.1"
                    :min="0.1"
                    placeholder="请输入"
                  ></el-input-number>
                  <span class="unit">元/kwh</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="标准服务费" prop="ormtb608ca06">
                  <el-input-number
                    v-model="ruleForm.ormtb608ca06"
                    :precision="2"
                    :step="0.1"
                    placeholder="请输入"
                  ></el-input-number>
                  <span class="unit">元/kwh</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <!-- 分时计费 -->
        <div class="time_share" v-if="ruleForm.ormtb608ca04 == 1">
          <!-- 分时电费 -->
          <div class="time_share_electricity">
            <div class="saleRate_add_title">分时电费</div>
            <div class="time_share_electricity_content">
              <el-row :gutter="20">
                <el-col :span="12" class="time_share_electricity_item">
                  <span class="bg_color bg_color_red"></span>
                  <el-form-item label="尖时电费" prop="ormtb608ca07">
                    <el-input-number
                      v-model="ruleForm.ormtb608ca07"
                      :precision="2"
                      :step="0.1"
                      :min="0.1"
                      placeholder="请输入"
                    ></el-input-number>
                    <span class="unit">元/kwh</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="time_share_electricity_item">
                  <span class="bg_color bg_color_yellow"></span>
                  <el-form-item label="峰时电费" prop="ormtb608ca08">
                    <el-input-number
                      v-model="ruleForm.ormtb608ca08"
                      :precision="2"
                      :step="0.1"
                      :min="0.1"
                      placeholder="请输入"
                    ></el-input-number>
                    <span class="unit">元/kwh</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="time_share_electricity_item">
                  <span class="bg_color bg_color_green"></span>
                  <el-form-item label="平时电费" prop="ormtb608ca09">
                    <el-input-number
                      v-model="ruleForm.ormtb608ca09"
                      :precision="2"
                      :step="0.1"
                      placeholder="请输入"
                      :min="0.1"
                    ></el-input-number>
                    <span class="unit">元/kwh</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="time_share_electricity_item">
                  <span class="bg_color bg_color_blue"></span>
                  <el-form-item label="谷时电费" prop="ormtb608ca10">
                    <el-input-number
                      v-model="ruleForm.ormtb608ca10"
                      :precision="2"
                      :step="0.1"
                      placeholder="请输入"
                      :min="0.1"
                    ></el-input-number>
                    <span class="unit">元/kwh</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <!-- 分时服务费 -->
          <div class="time_share_electricity">
            <div class="saleRate_add_title">分时服务费</div>
            <div class="time_share_electricity_content">
              <el-row :gutter="20">
                <el-col :span="12" class="time_share_electricity_item">
                  <span class="bg_color bg_color_red"></span>
                  <el-form-item label="尖时服务费" prop="ormtb608ca11">
                    <el-input-number
                      v-model="ruleForm.ormtb608ca11"
                      :precision="2"
                      :step="0.1"
                      placeholder="请输入"
                    ></el-input-number>
                    <span class="unit">元/kwh</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="time_share_electricity_item">
                  <span class="bg_color bg_color_yellow"></span>
                  <el-form-item label="峰时服务费" prop="ormtb608ca12">
                    <el-input-number
                      v-model="ruleForm.ormtb608ca12"
                      :precision="2"
                      :step="0.1"
                      placeholder="请输入"
                    ></el-input-number>
                    <span class="unit">元/kwh</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="time_share_electricity_item">
                  <span class="bg_color bg_color_green"></span>
                  <el-form-item label="平时服务费" prop="ormtb608ca13">
                    <el-input-number
                      v-model="ruleForm.ormtb608ca13"
                      :precision="2"
                      :step="0.1"
                      placeholder="请输入"
                    ></el-input-number>
                    <span class="unit">元/kwh</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="time_share_electricity_item">
                  <span class="bg_color bg_color_blue"></span>
                  <el-form-item label="谷时服务费" prop="ormtb608ca14">
                    <el-input-number
                      v-model="ruleForm.ormtb608ca14"
                      :precision="2"
                      :step="0.1"
                      placeholder="请输入"
                    ></el-input-number>
                    <span class="unit">元/kwh</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="saleRate_prompt">
            <i class="el-icon-warning"></i
            >请确保充电桩支持【分时服务费】如果不支持请填写相同的服务费，否则充电桩将以最小金额的服务费金额生效
          </div>
        </div>
        <!-- 时间选择 -->
        <div class="saleRate_time" v-if="ruleForm.ormtb608ca04 == 1">
          <div class="saleRate_time_tab">
            <div
              class="saleRate_time_tab_item"
              :style="{ backgroundColor: tabColors[index] }"
              v-for="(item, index) in timeTab"
              :key="index"
              :class="{ tab_active: timeTabIndex == index }"
              @click="timeTabClick(index, item)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="saleRate_time_content">
            <el-row>
              <el-col
                :span="4"
                class="saleRate_content_item"
                :style="{
                  backgroundColor: getBackgroundColor(index),
                  color: coloredItems[index] ? '#fff' : '',
                }"
                v-for="(item, index) in timeList"
                :key="index"
                @click.native="handleTime(index, item)"
                >{{ item.time }}</el-col
              >
            </el-row>
          </div>
        </div>
      </el-form>
    </div>
    <!-- 提交按钮 -->
    <div class="submit_btns">
      <el-button class="submit_btns_left" @click="cancelForm">取消</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {
        ormtb608ca01: '', //规则名称
        ormtb608ca02: '', //服务计费说明
        ormtb608ca04: 0, //计费规则模式 0标准计费 1分时计费
        ormtb608ca05: undefined, //标准电费（计费规则模式为0时有值）
        ormtb608ca06: undefined, //标准服务费（计费规则模式为0时有值）
        ormtb608ca07: undefined, //尖时电费（计费规则模式为1时有值）
        ormtb608ca08: undefined, //峰时电费（计费规则模式为1时有值）
        ormtb608ca09: undefined, //平时电费（计费规则模式为1时有值）
        ormtb608ca10: undefined, //谷时电费（计费规则模式为1时有值）
        ormtb608ca11: undefined, //尖时服务费（计费规则模式为1时有值）
        ormtb608ca12: undefined, //峰时服务费（计费规则模式为1时有值）
        ormtb608ca13: undefined, //平时服务费（计费规则模式为1时有值）
        ormtb608ca14: undefined, //谷时服务费（计费规则模式为1时有值）
        ormtb608ca15: '', //下发时间
        ormtb601id: '', //下发范围
        list: [], //下发范围数组格式
      },
      rules: {
        ormtb608ca01: [
          { required: true, message: '费率名称不能为空', trigger: 'blur' },
        ],
        ormtb601id: [
          { required: true, message: '下发范围不能为空', trigger: 'blur' },
        ],
        ormtb608ca05: [
          { required: true, message: '标准电费不能为空', trigger: 'blur' },
        ],
        ormtb608ca06: [
          { required: true, message: '标准服务费不能为空', trigger: 'blur' },
        ],
        ormtb608ca07: [
          { required: true, message: '充电费率-尖不能为空', trigger: 'blur' },
        ],
        ormtb608ca08: [
          { required: true, message: '充电费率-峰不能为空', trigger: 'blur' },
        ],
        ormtb608ca09: [
          { required: true, message: '充电费率-平不能为空', trigger: 'blur' },
        ],
        ormtb608ca10: [
          { required: true, message: '充电费率-谷不能为空', trigger: 'blur' },
        ],
        ormtb608ca11: [
          { required: true, message: '服务费率-尖不能为空', trigger: 'blur' },
        ],
        ormtb608ca12: [
          { required: true, message: '服务费率-峰不能为空', trigger: 'blur' },
        ],
        ormtb608ca13: [
          { required: true, message: '服务费率-平不能为空', trigger: 'blur' },
        ],
        ormtb608ca14: [
          { required: true, message: '服务费率-谷不能为空', trigger: 'blur' },
        ],
      },
      stationList: [],
      timeTab: [
        {
          type: 1,
          name: '尖',
        },
        {
          type: 2,
          name: '峰',
        },
        {
          type: 3,
          name: '平',
        },
        {
          type: 4,
          name: '谷',
        },
      ],
      timeTabIndex: 0,
      tabColors: ['#FF0000', '#F8AC59', '#23C6C8', '#1AB394'],
      timeList: [],
      type: null,
      coloredItems: {}, // 存储已点击项的颜色状态,
      selectTimeList: [],
      timeTabName: '尖',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now()
        },
      },
      timeSlotList: [],
    }
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  watch: {
    id: {
      handler(newVal) {
        if (newVal) {
          console.log('修改')
          // 修改
          this.timeList = []
          this.coloredItems = {}
          this.timeTabIndex = 0
          this.timeTabName = '尖'

          this.getDetail()
        } else {
          console.log('新增')
          // 新增
          this.ruleForm = {
            ormtb608ca01: '', //规则名称
            ormtb608ca02: '', //服务计费说明
            ormtb608ca04: 0, //计费规则模式 0标准计费 1分时计费
            ormtb608ca05: undefined, //标准电费（计费规则模式为0时有值）
            ormtb608ca06: undefined, //标准服务费（计费规则模式为0时有值）
            ormtb608ca07: undefined, //尖时电费（计费规则模式为1时有值）
            ormtb608ca08: undefined, //峰时电费（计费规则模式为1时有值）
            ormtb608ca09: undefined, //平时电费（计费规则模式为1时有值）
            ormtb608ca10: undefined, //谷时电费（计费规则模式为1时有值）
            ormtb608ca11: undefined, //尖时服务费（计费规则模式为1时有值）
            ormtb608ca12: undefined, //峰时服务费（计费规则模式为1时有值）
            ormtb608ca13: undefined, //平时服务费（计费规则模式为1时有值）
            ormtb608ca14: undefined, //谷时服务费（计费规则模式为1时有值）
            ormtb608ca15: '', //下发时间
            ormtb601id: '', //下发范围
            list: [], //下发范围数组格式
          }
          this.timeTabIndex = 0
          this.timeList = this.generateTimeSlotsBetter()
          this.coloredItems = {}
          this.selectTimeList = []
          this.timeTabName = '尖'
        }
      },
      immediate: true,
    },
  },
  created() {
    // this.timeList = this.generateTimeSlotsBetter();
    this.getList()
  },
  methods: {
    // 获取详情信息
    getDetail() {
      var url = 'orm/ormtb608/detail'
      this.axios
        .post(url, { ormtb608id: this.id })
        .then(res => {
          if (res.data.code == 200) {
            let objData = res.data.data
            objData.ormtb608ca04 = Number(objData.ormtb608ca04)
            objData.list = objData.ormtb601IdList
            objData.ormtb601id = objData.ormtb601IdList.join(',')
            this.ruleForm = res.data.data
            // if (this.ruleForm.ormtb608ca01.includes('复制')) {
            //   console.log('数字?', this.ruleForm.ormtb608ca01(/\d+/g) || [])
            // } else {
            //   this.ruleForm.ormtb608ca01 =
            //     this.ruleForm.ormtb608ca01 + '-' + '复制1'
            //   console.log('meiy1')
            // }
            // let flag = this.ruleForm.ormtb608ca01.includes('复制')
            // this.ruleForm.ormtb608ca01 = !flag
            //   ? this.ruleForm.ormtb608ca01 + '-' + '复制1'
            //   : this.ruleForm.ormtb608ca01
            // if (flag) {
            //   let num = this.getAllNumbers(this.ruleForm.ormtb608ca01)
            //   let num1 = Number(num) + 1
            //   console.log('num', num)
            //   this.ruleForm.ormtb608ca01 =
            //     this.truncatedString(this.ruleForm.ormtb608ca01) +
            //     '-' +
            //     '复制' +
            //     num1
            // }

            if (res.data.data.ormtb604List.length) {
              this.timeList = res.data.data.ormtb604List
            } else {
              this.timeTabIndex = 0
              this.timeList = this.generateTimeSlotsBetter()
            }
            this.selectTimeList = res.data.data.ormtb604List
            this.timeList.forEach((item, index) => {
              item.time = `${item.ormtb604ca01}-${item.ormtb604ca02}`
              let type = null
              if (item.ormtb604ca05 == '尖') {
                type = 0
              } else if (item.ormtb604ca05 == '峰') {
                type = 1
              } else if (item.ormtb604ca05 == '平') {
                type = 2
              } else if (item.ormtb604ca05 == '谷') {
                type = 3
              }
              this.$set(this.coloredItems, index, this.tabColors[type])
            })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {})
    },
    truncatedString(input) {
      const str = input
      const lastIndex = str.lastIndexOf('-')

      // 如果不存在 '-' 或 '-' 在末尾，直接返回原字符串
      if (lastIndex === -1) return str

      // 截取最后一个 '-' 之前的内容
      return str.substring(0, lastIndex)
    },
    getAllNumbers(input) {
      if (typeof input !== 'string') return []
      const matches = input.match(/-?\d+(\.\d+)?/g) || []
      return matches.map(num => parseFloat(num))
    },
    //下发范围change事件
    getSelectData(e) {
      this.ruleForm.ormtb601id = e.join(',')
    },
    //获取站点列表
    getList() {
      var url = 'orm/ormtb601/selecAll601'
      this.axios
        .post(url)
        .then(res => {
          if (res.data.code == 200) {
            this.stationList = res.data.data
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {})
    },
    handleTime(index, item) {
      // this.type = this.timeTabIndex;
      this.$set(this.coloredItems, index, this.tabColors[this.timeTabIndex])
      let obj = {}
      if (this.timeTabName == '尖') {
        //尖
        obj = {
          ormtb604ca01: item.ormtb604ca01,
          ormtb604ca02: item.ormtb604ca02,
          ormtb604ca03: this.ruleForm.ormtb608ca07,
          ormtb604ca04: this.ruleForm.ormtb608ca11,
          ormtb604ca05: this.timeTabName,
        }
      }
      if (this.timeTabName == '峰') {
        obj = {
          ormtb604ca01: item.ormtb604ca01,
          ormtb604ca02: item.ormtb604ca02,
          ormtb604ca03: this.ruleForm.ormtb608ca08,
          ormtb604ca04: this.ruleForm.ormtb608ca12,
          ormtb604ca05: this.timeTabName,
        }
      }
      if (this.timeTabName == '平') {
        obj = {
          ormtb604ca01: item.ormtb604ca01,
          ormtb604ca02: item.ormtb604ca02,
          ormtb604ca03: this.ruleForm.ormtb608ca09,
          ormtb604ca04: this.ruleForm.ormtb608ca13,
          ormtb604ca05: this.timeTabName,
        }
      }
      if (this.timeTabName == '谷') {
        obj = {
          ormtb604ca01: item.ormtb604ca01,
          ormtb604ca02: item.ormtb604ca02,
          ormtb604ca03: this.ruleForm.ormtb608ca10,
          ormtb604ca04: this.ruleForm.ormtb608ca14,
          ormtb604ca05: this.timeTabName,
        }
      }
      this.selectTimeList = this.updateOrAddObject(this.selectTimeList, obj)
    },
    updateOrAddObject(array, obj) {
      // 查找数组中是否存在与 obj.ormtb604ca01 相同的对象
      const foundIndex = array.findIndex(
        item => item.ormtb604ca01 === obj.ormtb604ca01
      )

      if (foundIndex !== -1) {
        // 如果找到，检查 ormtb604ca05 是否相同
        if (array[foundIndex].ormtb604ca05 !== obj.ormtb604ca05) {
          // 如果不相同，更新 ormtb604ca05 的值
          array[foundIndex].ormtb604ca05 = obj.ormtb604ca05
          console.log('已更新 ormtb604ca05 的值')
        } else {
          console.log('ormtb604ca05 值相同，无需修改')
        }
      } else {
        // 如果没找到，添加新对象到数组
        array.push(obj)
        console.log('已添加新对象到数组')
      }

      return array
    },
    getBackgroundColor(index) {
      return this.coloredItems[index] || 'transparent'
    },
    cancelForm() {
      this.$emit('cancelForm')
    },
    generateTimeSlotsBetter() {
      const slots = []
      for (let i = 0; i < 48; i++) {
        const startHour = Math.floor(i / 2)
        const startMinute = i % 2 === 0 ? '00' : '30'

        let endHour, endMinute
        if (i === 47) {
          // 最后一个时间段
          endHour = '24'
          endMinute = '00'
        } else {
          const nextHalf = i + 1
          endHour = Math.floor(nextHalf / 2)
            .toString()
            .padStart(2, '0')
          endMinute = nextHalf % 2 === 0 ? '00' : '30'
        }

        const start = `${startHour.toString().padStart(2, '0')}:${startMinute}`
        const end = `${endHour}:${endMinute}`
        slots.push({
          ormtb604ca01: start,
          ormtb604ca02: end,
          time: `${start}-${end}`,
        })
      }
      return slots
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (
            this.selectTimeList.length < this.timeList.length &&
            this.ruleForm.ormtb608ca04 == 1
          ) {
            this.$message.error('分时计费模式下,请覆盖全天所有时段')
            return false
          }
          let loading = this.$loading({
            lock: true,
            text: '请求中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.5)',
          })
          var postData = {}
          if (this.ruleForm.ormtb608ca04 == 0) {
            postData = {
              ormtb608ca01: this.ruleForm.ormtb608ca01,
              ormtb608ca02: this.ruleForm.ormtb608ca02,
              ormtb608ca03: this.ruleForm.ormtb608ca03,
              ormtb608ca04: this.ruleForm.ormtb608ca04,
              ormtb608ca05: this.ruleForm.ormtb608ca05,
              ormtb608ca06: this.ruleForm.ormtb608ca06,
              ormtb608ca15: this.ruleForm.ormtb608ca15,
              ormtb601id: this.ruleForm.ormtb601id,
            }
          } else {
            postData = {
              ormtb608ca01: this.ruleForm.ormtb608ca01,
              ormtb608ca02: this.ruleForm.ormtb608ca02,
              ormtb608ca03: this.ruleForm.ormtb608ca03,
              ormtb608ca04: this.ruleForm.ormtb608ca04,
              ormtb608ca07: this.ruleForm.ormtb608ca07,
              ormtb608ca08: this.ruleForm.ormtb608ca08,
              ormtb608ca09: this.ruleForm.ormtb608ca09,
              ormtb608ca10: this.ruleForm.ormtb608ca10,
              ormtb608ca11: this.ruleForm.ormtb608ca11,
              ormtb608ca12: this.ruleForm.ormtb608ca12,
              ormtb608ca13: this.ruleForm.ormtb608ca13,
              ormtb608ca14: this.ruleForm.ormtb608ca14,
              ormtb608ca15: this.ruleForm.ormtb608ca15,
              ormtb601id: this.ruleForm.ormtb601id,
              ormtb604List: this.selectTimeList,
            }
          }
          if (this.id) {
            //修改
            var url = 'orm/ormtb608/update'
            this.axios
              .post(url, { ...postData, ormtb608id: this.id })
              .then(res => {
                setTimeout(() => {
                  loading.close()
                }, 400)
                if (res.data.code == 200) {
                  this.$message({
                    message: res.data.message,
                    type: 'success',
                  })
                  this.$emit('submitForm')
                } else {
                  this.$message({
                    message: res.data.message,
                    type: 'error',
                  })
                }
              })
              .catch(() => {
                loading.close()
              })
          } else {
            //新增
            var url = 'orm/ormtb608/add'
            this.axios
              .post(url, postData)
              .then(res => {
                setTimeout(() => {
                  loading.close()
                }, 400)
                if (res.data.code == 200) {
                  this.$message({
                    message: res.data.message,
                    type: 'success',
                  })
                  this.$emit('submitForm')
                } else {
                  this.$message({
                    message: res.data.message,
                    type: 'error',
                  })
                }
              })
              .catch(() => {
                loading.close()
              })
          }
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    timeTabClick(index, item) {
      this.timeTabIndex = index
      this.timeTabName = item.name
    },
  },
}
</script>
<style scoped>
.saleRate_content {
  max-height: 80vh;
  overflow-y: auto;
  overflow: -moz-scrollbars-none;
  /* 旧版 Firefox */
  scrollbar-width: none;
  /* 新版 Firefox */
  -ms-overflow-style: none;
  /* IE and Edge */
}

.saleRate_content::-webkit-scrollbar {
  width: 0 !important;
  /* Chrome, Safari and Opera */
  height: 0 !important;
}

.saleRate_add_title {
  height: 66px;
  line-height: 66px;
  color: #333333;
  font-size: 18px;
}

.el-form-item {
  display: flex;
}

/deep/.el-form-item__content {
  flex: 1;
  margin-left: 0 !important;
}

/deep/.el-form-item__label {
  width: 90px !important;
  padding: 0 !important;
}

.saleRate_add_title {
  border-top: 1px solid #d9d9d9;
}

.saleRate_add_content_title {
  padding: 20px 0 20px 19px;
  box-sizing: border-box;
  font-size: 16px;
}

.saleRate_setup_radio {
  padding: 0 0 40px 70px;
  box-sizing: border-box;
}

.unit {
  margin-left: 19px;
  color: #9e9e9e;
}

.time_share_electricity_content {
  padding: 0 20px;
  box-sizing: border-box;
}

.time_share_electricity_item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.bg_color {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 10px;
}

.time_share_electricity_item .el-form-item {
  margin: 0 !important;
}

.saleRate_prompt {
  font-size: 14px !important;
  color: #ff0000;
}

.saleRate_time_tab {
  display: flex;
  align-items: center;
  height: 72px;
}

.saleRate_time_tab_item {
  width: 42px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background: #f8ac59;
  margin-right: 14px;
  font-size: 14px;
  color: #fff;
}

.tab_active {
  width: 42px;
  height: 32px;
  line-height: 32px;
  font-size: 18px;
}

.saleRate_time_content {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid #d8d8d8;
  border-left: 1px solid #d8d8d8;
}

.saleRate_content_item {
  /* width: 142px; */
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-right: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
}

.bg_color_red {
  background: #ed5565;
}

.bg_color_yellow {
  background: #f8ac59;
}

.bg_color_green {
  background: #23c6c8;
}

.bg_color_blue {
  background: #1a8f77;
}
/* 提交按钮 */
.submit_btns {
  padding-top: 20px;
  display: flex;
  justify-content: end;
}

.submit_btns_left {
  color: #d9d9d9;
}
</style>
